import { ChangedFilter } from 'types/legacy/backendInformation';

import { ChangedHighlightType, Highlight } from '../types';

import { changedFilterMapping } from './integratedOvernightRouteMapping';

export const getHighlightData = (changedFilter: ChangedFilter) => {
    let openType: ChangedHighlightType = ChangedHighlightType.None;
    const changedInfo: Highlight = {
        travelDate: false,
        travellerOrRoom: false,
        days: false,
    };

    for (const key in changedFilter) {
        changedFilterMapping.forEach((mapping) => {
            if (mapping.fieldStack.indexOf(key) > -1) {
                changedInfo[mapping.dataKey] = true;
                if (openType === ChangedHighlightType.None) {
                    openType = mapping.dataKey as ChangedHighlightType;
                }
            }
        });
    }

    const showTooltip =
        Object.values(changedInfo).filter((type) => !!type).length > 0;

    return { changedInfo, openType, showTooltip };
};
